export const timeEntriesTranslations = {
  // Time entries general
  "timeEntries": {
    en: "Time Entries",
    fi: "Tuntikirjaukset"
  },
  "timeEntries.weekView": {
    en: "Time Entries - Week View",
    fi: "Tuntikirjaukset - Viikkonäkymä"
  },
  "timeEntries.dayView": {
    en: "Time Entries - Day View",
    fi: "Tuntikirjaukset - Päivänäkymä"
  },
  "timeEntries.week": {
    en: "Week",
    fi: "Viikko"
  },
  "timeEntries.day": {
    en: "Day",
    fi: "Päivä"
  },
  "timeEntries.weekShort": {
    en: "Wk",
    fi: "Vko"
  },
  "timeEntries.month": {
    en: "Month",
    fi: "Kuukausi"
  },
  "timeEntries.addRow": {
    en: "Add New Row",
    fi: "Lisää uusi rivi"
  },
  "timeEntries.addEntry": {
    en: "Add New Entry",
    fi: "Lisää uusi merkintä"
  },
  "timeEntries.newRow": {
    en: "New Row",
    fi: "Uusi rivi"
  },
  "timeEntries.editRow": {
    en: "Edit Row",
    fi: "Muokkaa riviä"
  },
  "timeEntries.editEntry": {
    en: "Edit Time Entry",
    fi: "Muokkaa tuntikirjausta"
  },
  "timeEntries.projectDetails": {
    en: "Project Details",
    fi: "Projektin tiedot"
  },
  "timeEntries.noEntries": {
    en: "No time entries for this week. Click 'Add Row' to get started.",
    fi: "Ei tuntikirjauksia tälle viikolle. Klikkaa 'Lisää rivi' aloittaaksesi."
  },
  "timeEntries.noEntriesDay": {
    en: "No time entries for this day. Click 'Add Entry' to get started.",
    fi: "Ei tuntikirjauksia tälle päivälle. Klikkaa 'Lisää merkintä' aloittaaksesi."
  },
  "timeEntries.saveAll": {
    en: "Save All",
    fi: "Tallenna kaikki"
  },
  "timeEntries.savedSuccessfully": {
    en: "Time entries saved successfully",
    fi: "Tuntikirjaukset tallennettu onnistuneesti"
  },
  "timeEntries.submit": {
    en: "Submit",
    fi: "Merkitse valmiiksi"
  },
  "timeEntries.submitDay": {
    en: "Day Ready",
    fi: "Päivä valmis"
  },
  "timeEntries.submitWeek": {
    en: "Week Ready",
    fi: "Viikko valmis"
  },
  "timeEntries.submittedSuccessfully": {
    en: "Time entries submitted successfully",
    fi: "Tuntikirjaukset lähetetty onnistuneesti"
  },
  "timeEntries.confirmSubmit": {
    en: "Are you sure you want to mark these time entries as ready?",
    fi: "Haluatko varmasti merkitä nämä tuntikirjaukset valmiiksi?"
  },
  "timeEntries.submitWarning": {
    en: "Once marked as ready, you will not be able to edit these entries.",
    fi: "Merkitsemisen jälkeen et voi enää muokata näitä kirjauksia."
  },
  "timeEntries.locked": {
    en: "Locked",
    fi: "Lukittu"
  },
  "timeEntries.deleteRow": {
    en: "Delete Row",
    fi: "Poista rivi"
  },
  "timeEntries.deleteEntry": {
    en: "Delete Entry",
    fi: "Poista merkintä"
  },
  "timeEntries.confirmDeleteRow": {
    en: "Are you sure you want to delete this row?",
    fi: "Haluatko varmasti poistaa tämän rivin?"
  },
  "timeEntries.confirmDeleteEntry": {
    en: "Are you sure you want to delete this entry?",
    fi: "Haluatko varmasti poistaa tämän merkinnän?"
  },
  "timeEntries.deletedSuccessfully": {
    en: "Time entries deleted successfully",
    fi: "Tuntikirjaukset poistettu onnistuneesti"
  },
  "timeEntries.allFieldsRequired": {
    en: "All fields are required",
    fi: "Kaikki kentät ovat pakollisia"
  },
  "timeEntries.projectFieldsRequired": {
    en: "Project and subproject are required",
    fi: "Projekti ja osaprojekti ovat pakollisia"
  },
  "timeEntries.newEntry": {
    en: "New Entry",
    fi: "Uusi tuntikirjaus"
  },
  "timeEntries.newTask": {
    en: "New Task",
    fi: "Uusi tehtävä"
  },
  // Form fields
  "timeEntries.project": {
    en: "Project",
    fi: "Projekti"
  },
  "timeEntries.subproject": {
    en: "Subproject",
    fi: "Osaprojekti"
  },
  "timeEntries.role": {
    en: "Price Group and Role",
    fi: "Hintaryhmä ja työvaihe"
  },
  "timeEntries.selectRole": {
    en: "Select a role",
    fi: "Valitse työvaihe"
  },
  "timeEntries.expert": {
    en: "Expert",
    fi: "Asiantuntija"
  },
  "timeEntries.salaryType": {
    en: "Salary Type",
    fi: "Palkkalaji"
  },
  "timeEntries.selectSalaryType": {
    en: "Select a salary type",
    fi: "Valitse palkkalaji"
  },
  "timeEntries.task": {
    en: "Task",
    fi: "Tehtävä"
  },
  "timeEntries.selectTask": {
    en: "Select a task",
    fi: "Valitse tehtävä"
  },
  "timeEntries.searchTask": {
    en: "Search task...",
    fi: "Hae tehtävää..."
  },
  "timeEntries.searchSubproject": {
    en: "Search subproject...",
    fi: "Hae osaprojektia..."
  },
  "timeEntries.noSubprojectsFound": {
    en: "No subprojects found",
    fi: "osaprojekteja ei löytynyt"
  },
  "timeEntries.noTasksFound": {
    en: "No tasks found",
    fi: "Tehtäviä ei löytynyt"
  },
  "timeEntries.description": {
    en: "Description",
    fi: "Selite"
  },
  "timeEntries.descriptionPlaceholder": {
    en: "Enter a description here",
    fi: "Kirjoita selite tähän"
  },

  "timeEntries.hours": {
    en: "Hours",
    fi: "Tunnit"
  },
  "timeEntries.weeklyHours": {
    en: "Weekly Hours",
    fi: "Viikon tunnit"
  },

  "timeEntries.approvalView": {
    en: "Approval View",
    fi: "Hyväksyntänäkymä"
  },
  "timeEntries.balance": {
    en: "Balance",
    fi: "Saldo"
  },
  "timeEntries.submittedEntries": {
    en: "Submitted Entries",
    fi: "Lähetetyt kirjaukset"
  },
  "timeEntries.hoursBySubproject": {
    en: "Hours by Subproject",
    fi: "Tunnit osaprojekteittain"
  },
  "timeEntries.goToApprovalView": {
    en: "Review Time Entries",
    fi: "Tarkastele tuntikirjauksia"
  },
  "timeEntries.entriesAwaitingApproval": {
    en: "Entries Awaiting Approval",
    fi: "Hyväksyntää odottavia merkintöjä"
  },

  // Select placeholders
  "timeEntries.selectProject": {
    en: "Select a project",
    fi: "Valitse projekti"
  },
  "timeEntries.selectSubproject": {
    en: "Select a subproject",
    fi: "Valitse osaprojekti"
  },

  // Salary types
  "timeEntries.normal": {
    en: "Normal",
    fi: "Normaali"
  },
  "timeEntries.overtime": {
    en: "Overtime",
    fi: "Ylityö"
  },
  "timeEntries.travel": {
    en: "Travel time",
    fi: "Matka-aika"
  },

  "timeEntries.weekend": {
    en: "Weekend",
    fi: "Viikonloppu"
  },

  "timeEntries.currentWeek": {
    en: "Current Week",
    fi: "Kuluva viikko"
  },

  "timeEntries.currentDay": {
    en: "Today",
    fi: "Tänään"
  },

  // Navigation warnings
  "timeEntries.cannotNavigateMoreThanOneMonthPast": {
    en: "You cannot navigate more than one month into the past",
    fi: "Et voi siirtyä yli kuukautta menneisyyteen"
  },
  "timeEntries.cannotNavigateAheadOfCurrentWeek": {
    en: "You cannot navigate ahead of the current week",
    fi: "Et voi siirtyä nykyistä viikkoa eteenpäin"
  },

  // Locale for date formatting
  "timeEntries.locale": {
    en: "en-US",
    fi: "fi-FI"
  },

  "timeEntries.total": {
    en: "TOTAL",
    fi: "YHT"
  },

  // Submit Questionnaire
  "timeEntries.ratingRequired": {
    en: "Please rate your week",
    fi: "Arvioi viikkosi"
  },
  "timeEntries.missingDaysTitle": {
    en: "Missing Days",
    fi: "Puuttuvat päivät"
  },
  "timeEntries.noMissingDays": {
    en: "All days have entries!",
    fi: "Kaikilla päivillä on merkintöjä!"
  },
  "timeEntries.missingDaysDescription": {
    en: "The following days are missing time entries:",
    fi: "Seuraavilla päivillä puuttuu tuntikirjauksia:"
  },
  "timeEntries.rateYourWeek": {
    en: "Rate Your Week",
    fi: "Arvioi viikkosi"
  },
  "timeEntries.ratingSelected": {
    en: "Rating:",
    fi: "Arvosana:"
  },
  "timeEntries.ratingExplanation": {
    en: "Explanation (Optional)",
    fi: "Selitys (valinnainen)"
  },
  "timeEntries.ratingExplanationPlaceholder": {
    en: "Why did you give this rating?",
    fi: "Miksi annoit tämän arvosanan?"
  },
  "timeEntries.recognizeColleague": {
    en: "Recognize a Colleague (Optional)",
    fi: "Tunnusta kollega (valinnainen)"
  },
  "timeEntries.recognizeColleagueDescription": {
    en: "Mention a colleague who did exceptionally well this week",
    fi: "Mainitse joku kollega joka onnistui erityisen hyvin tällä viikolla"
  },
  "timeEntries.selectColleague": {
    en: "Select Colleague",
    fi: "Valitse kollega"
  },
  "timeEntries.selectColleaguePlaceholder": {
    en: "Choose a colleague...",
    fi: "Valitse kollega..."
  },
  "timeEntries.expertDescription": {
    en: "Short description:",
    fi: "Lyhyt kuvaus:"
  },
  "timeEntries.expertDescriptionPlaceholder": {
    en: "Describe what they did well...",
    fi: "Kuvaile mitä he tekivät hyvin..."
  },
  "timeEntries.next": {
    en: "Next",
    fi: "Seuraava"
  },
  "timeEntries.previous": {
    en: "Previous",
    fi: "Edellinen"
  },

  "timeEntries.time": {
    en: "Time",
    fi: "Tunnit"
  },
  "timeEntries.approval": {
    en: "Approval",
    fi: "Hyväksyminen"
  },
  // Approval View
  "timeEntries.approvalAndReporting": {
    en: "Approval and reporting",
    fi: "Hyväksyminen ja raportointi"
  },
  "timeEntries.totalEntries": {
    en: "Total entries",
    fi: "Kirjauksia yhteensä"
  },
  "timeEntries.waitingForApproval": {
    en: "Waiting for approval",
    fi: "Odottaa hyväksyntää"
  },
  "timeEntries.entriesApproved": {
    en: "Entries approved",
    fi: "Kirjauksia hyväksytty"
  },
  "timeEntries.units": {
    en: "entries",
    fi: "kpl"
  },
  "timeEntries.checkedWithNoIssuesFound": {
    en: "Checked automatically with no issues found",
    fi: "Esitarkastettu automaattisesti ilman huomioita"
  },
  "timeEntries.notApproved": {
    en: "Not Approved",
    fi: "Hyväksymättä"
  },
  "timeEntries.all": {
    en: "All",
    fi: "Kaikki"
  },
  "timeEntries.issues": {
    en: "Issues",
    fi: "Huomiot"
  },
  "timeEntries.travelEntries": {
    en: "Travel Entries",
    fi: "Matkakirjaukset"
  },
  "timeEntries.badDescription": {
    en: "Bad Description",
    fi: "Puutteellinen selite"
  },
  "timeEntries.sickLeave": {
    en: "Sick Leave",
    fi: "Sairausloma"
  },
  "timeEntries.paidVacation": {
    en: "Paid Vacation",
    fi: "Palkallinen loma"
  },
  "timeEntries.lateVacation": {
    en: "Late Vacation",
    fi: "Myöhäinen lomakirjaus"
  },
  "timeEntries.insufficientVacation": {
    en: "Insufficient Vacation",
    fi: "Ei tarpeeksi lomapäiviä"
  },
  "timeEntries.results": {
    en: "results",
    fi: "tulosta"
  },
  "timeEntries.approveAll": {
    en: "Approve All",
    fi: "Hyväksy kaikki"
  },
  "timeEntries.approveSelected": {
    en: "Approve Selected",
    fi: "Hyväksy valitut"
  },
  "timeEntries.selectAll": {
    en: "Select All",
    fi: "Valitse kaikki"
  },
  "timeEntries.deselectAll": {
    en: "Deselect All",
    fi: "Poista valinnat"
  },
  "timeEntries.loading": {
    en: "Loading...",
    fi: "Ladataan..."
  },
  "timeEntries.noEntriesToDisplay": {
    en: "No entries to display",
    fi: "Ei näytettäviä kirjauksia"
  },
  "timeEntries.noDescription": {
    en: "No description",
    fi: "Ei selitettä"
  },
  "timeEntries.approved": {
    en: "Approved",
    fi: "Hyväksytty"
  },
  "timeEntries.approve": {
    en: "Approve",
    fi: "Hyväksy"
  },
  "timeEntries.confirmApproval": {
    en: "Confirm Approval",
    fi: "Vahvista hyväksyntä"
  },
  "timeEntries.confirmApprovalMessage": {
    en: "Are you sure you want to approve",
    fi: "Haluatko varmasti hyväksyä"
  },
  "timeEntries.entry": {
    en: "entry",
    fi: "kirjauksen"
  },
  "timeEntries.entries": {
    en: "entries",
    fi: "kirjausta"
  },
  "timeEntries.failedToFetchData": {
    en: "Failed to fetch data",
    fi: "Tietojen hakeminen epäonnistui"
  },
  "timeEntries.failedToApproveEntry": {
    en: "Failed to approve entry",
    fi: "Kirjauksen hyväksyminen epäonnistui"
  },
  "timeEntries.failedToApproveEntries": {
    en: "Failed to approve entries",
    fi: "Kirjausten hyväksyminen epäonnistui"
  },
  "timeEntries.travelEntry": {
    en: "Travel Entry",
    fi: "Matkakirjaus"
  },
  "timeEntries.allProjects": {
    en: "All projects",
    fi: "Kaikki projektit"
  },
  "timeEntries.allSubprojects": {
    en: "All subprojects",
    fi: "Kaikki osaprojektit"
  },
  "timeEntries.allExperts": {
    en: "All experts",
    fi: "Kaikki asiantuntijat"
  },
  "timeEntries.unapprove": {
    en: "Unapprove",
    fi: "Peru hyväksyntä"
  },
  "timeEntries.failedToUnapproveEntry": {
    en: "Failed to unapprove entry",
    fi: "Kirjauksen hyväksynnän peruminen epäonnistui"
  },
  "timeEntries.showOwnProjects": {
    en: "Show own projects",
    fi: "Näytä omat projektit"
  }
};
